module.exports = __webpack_public_path__ + "static/media/loewy_aperol.d3550115.jpg";